import { Injectable } from '@angular/core';
import WaveSurfer, { WaveSurferOptions } from 'wavesurfer.js';

@Injectable({
  providedIn: 'root'
})
export class WaveformService {
  initWaveform(options: WaveSurferOptions): WaveSurfer {
    return WaveSurfer.create(options);
  }
}
